/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import RETAIL from '../BaseComponent/RETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Loader from '../loaders/loader'

class detailsPaid extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lengthProducts: 0,
      listPaid: [],
      printInfo: [],
      modalDelete: false,
      modalEdit: false,
      paymentList: [],
      hasRef: false,
      aggregation: {},
      bankReference: ''
    }
  }

  changeSelect(e) {
    // alert(e.target.value)
    // alert(this.state.paymentList[0]['id'])
    // alert(this.state.paymentList[1]['id'])
    // alert(this.state.paymentList[2]['id'])
    // alert(this.state.paymentList[3]['id'])
    // alert(JSON.stringify(this.state.paymentList))
    if (e.target.value === '') {
      this.setState({
        hasRef: false,
        bankReference: ''
      })
    }
    for (let i = 0; i < this.state.paymentList.length; i++) {
      if (Number(this.state.paymentList[i]['id']) === Number(e.target.value)) {
        this.setState(
          {
            hasRef: this.state.paymentList[i]['hasRef']
          },
          () => {
            if (!this.state.hasRef) {
              this.setState({
                bankReference: ''
              })
            }
          }
        )
      } else {
        // this.setState({
        //     hasRef: false
        // })
      }
    }
  }

  getDetailPaid = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal')
  ) => {
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_DETAIL
        }?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            listPaid: response.data.object.result,
            lengthProducts: response.data.object.countAll,
            aggregation: response.data.object.aggregation
          })
        } else {
          // message.error(response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    let {driverId} = this.props.match.params

    http.get(`user/manage/payment/terminal/user/get/${driverId}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          paymentList: response.data.object
        })
      }
    })

    sessionStorage.removeItem('params')
    var {detailId} = this.props.match.params

    console.log(this.props.match.params)
    sessionStorage.setItem('detailIdforAdd', detailId)

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', `detailId=${detailId}`)
    this.getDetailPaid()
  }

  onResultFetched(data) {
    this.setState({
      listPaid: data
    })
  }

  changeDropDown(data) {
    this.setState({
      listPaid: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  convertState = (x) => {
    if (x === -100) {
      x = 'کنسل'
      return x
    } else if (x === -75) {
      x = 'مرجوعی'
      return x
    } else if (x === -50) {
      x = 'بازگشتی'
      return x
    } else if (x === -25) {
      x = 'تخصیص مجدد'
      return x
    } else if (x === -1) {
      x = 'تخصیص داده نشده'
      return x
    } else if (x === 1) {
      x = 'فعال'
      return x
    } else if (x === 5) {
      x = 'اول فعال'
      return x
    } else if (x === 10) {
      x = 'شروع شده'
      return x
    } else if (x === 18) {
      x = 'تسویه نشده'
      return x
    } else if (x === 20) {
      x = 'تسویه شده'
      return x
    }
  }

  delete = (id) => {
    var paymentId = this.state.listPaid[id].paymentId
    sessionStorage.setItem('paymentId', paymentId)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('paymentId')
  }

  deleteOk = () => {
    var paymentId = sessionStorage.getItem('paymentId')
    let data = {
      paymentId: paymentId
    }
    this.setState({
      loading: true
    })
    http
      .post(`${RETAIL.RETAIL_OPERATOR_DELIVERYPACK_PAYMENT_DELETE}`, data, {})
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          message.success('پرداخت با موفقیت حذف شد')
          sessionStorage.removeItem('params')
          var {detailId} = this.props.match.params
          this.setState({
            modalDelete: !this.state.modalDelete
          })
          console.log(this.props.match.params)
          sessionStorage.setItem('params', `detailId=${detailId}`)

          this.getDetailPaid()
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  edit = (id) => {
    var paymentId = this.state.listPaid[id].paymentId
    var accountId = this.state.listPaid[id].account.id
    let findSelectedPayment = this.state.paymentList.find((item) => item.id === accountId)
    if (findSelectedPayment) {
      this.setState({
        hasRef: findSelectedPayment.hasRef
      })
    } else {
      this.setState({
        hasRef: false
      })
    }
    var amount = this.state.listPaid[id].amount
    var bankReference = this.state.listPaid[id].bankReference === null ? '' : this.state.listPaid[id].bankReference
    var detailId = this.state.listPaid[id].dispatch.detailId
    sessionStorage.setItem('paymentId', paymentId)
    sessionStorage.setItem('amount', amount)
    sessionStorage.setItem('accountId', accountId)
    sessionStorage.setItem('detailId', detailId)
    sessionStorage.setItem('bankReference', bankReference)
    this.setState({
      modalEdit: !this.state.modalEdit,
      bankReference: bankReference
    })
  }

  editCancel = () => {
    this.setState({
      modalEdit: !this.state.modalEdit,
      bankReference: ''
    })
    sessionStorage.removeItem('paymentId')
    sessionStorage.removeItem('detailId')
    sessionStorage.removeItem('amount')
    sessionStorage.removeItem('accountId')
    sessionStorage.removeItem('bankReference')
  }
  editOk = () => {
    var paymentId = sessionStorage.getItem('paymentId')
    var detailId = sessionStorage.getItem('detailIdforAdd')
    var amount = document.getElementById('amount').value
    var bankRefrence = this.state.bankReference
    var typePaymentId = document.getElementById('typePaymentId').value

    var amountError = false
    var bankRefrenceError = false
    var typePaymentIdError = false
    var formError = false
    if (amount === '') {
      formError = true
      amountError = true
      message.error('مقدار وارد شود')
    } else {
      if (!amountError) {
        this.setState({
          error: ''
        })
      }
    }

    if (typePaymentId === '') {
      formError = true
      typePaymentIdError = true
      message.error('نوع پرداخت را وارد کنید')
    } else {
      if (!typePaymentIdError) {
        this.setState({
          error: ''
        })
      }
    }
    // if(this.state.hasRef && bankRefrence===''){
    //     formError = true;
    //     bankRefrenceError = true;
    //     message.error('رفرنس را وارد کنید')
    // }
    // else {
    //     if (!bankRefrenceError) {
    //         this.setState({
    //             error: ''
    //         })
    //     }
    // }

    if (!formError) {
      let findTerminalId = this.state.paymentList.find((item) => +item.id === +typePaymentId)
      let data = {
        amount: amount,

        detailId: detailId,
        typePaymentId: typePaymentId,
        bankReference: this.state.hasRef ? bankRefrence : undefined,
        paymentId: paymentId,
        terminalId: findTerminalId ? findTerminalId.terminalId : undefined
      }
      this.setState({
        loading: true
      })

      http
        .post(`${RETAIL.RETAIL_OPERATOR_DELIVERYPACK_PAYMENT_EDIT}`, data)
        .then((response) => {
          this.setState({
            loading: false
          })
          if (response.data.error === null) {
            message.success(' پرداخت ویرایش  شد')
            this.setState({
              modalEdit: !this.state.modalEdit
            })
            this.getDetailPaid()
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            this.setState({
              modalEdit: !this.state.modalEdit
            })
          }
        })
        .catch((error) => {
          this.setState({
            loading: false
          })
          alert(JSON.stringify(error))
        })
    }
  }

  getPrintInfo = () => {
    var {detailId} = this.props.match.params

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_DETAIL}?export=true&detailId=${detailId}`, {})
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_DETAIL
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error === null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['lastState'] = this.convertState(excelReport[i]['lastState'])

            if (excelReport[i]['paymentTime'] === null) {
              excelReport[i]['paymentTime'] = ''
            } else {
              excelReport[i]['paymentTime'] = jMoment(excelReport[i]['paymentTime']).format('jYYYY/jM/jD HH:mm')
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  changeRefrence = (e) => {
    this.setState({
      bankReference: e.target.value
    })
  }

  render() {
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let url = `${REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_DETAIL}?export=true`
    let urlParams = sessionStorage.getItem('params')
    let reporterName = cookie.load('name')
    var amount = sessionStorage.getItem('amount')
    var bankReference = sessionStorage.getItem('bankReference')
    var accountId = sessionStorage.getItem('accountId')

    let excelColumns = [
      {title: 'نام', value: 'name'},
      {title: 'رنگ', value: 'color'},
      {title: 'مدل', value: 'year'},
      {title: 'ظرفیت', value: 'capacity'},
      {title: 'شماره پلاک', value: 'plateNumber'},
      {title: 'سریال پلاک', value: 'plateText'}
    ]

    let printCol = [
      'ردیف',
      'شناسه پارت تحویل',
      'شناسه فاکتور',
      'حالت',
      'مبلغ',
      'نحوه پرداخت',
      'اسم بانک',
      'رفرنس بانک',
      'زمان پرداخت'
    ]

    let {invoiceId, name} = this.props.match.params

    return (
      <div className="rtl printA4Page">
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'گزارش جزییات پرداختی ' + name + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'deliveryPackId'}
                field={'dispatch.deliveryPackId'}
                title={'شناسه پارت تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceId'}
                field={'dispatch.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'lastState'}
                field={'dispatch.lastState'}
                title={'حالت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'amount'}
                field={'amount'}
                title={'مبلغ'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'accountName'}
                field={'account.name'}
                title={'نحوه پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'accountBank'}
                field={'account.bank'}
                title={'اسم بانک'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'bankRefrense'}
                field={'bankRefrense'}
                title={'اسم بانک'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'paymentTime'}
                field={'paymentTime'}
                title={'زمان پرداخت'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header={'گزارش پرداختی رساننده : ' + name + ' با شناسه فاکتور : ' + invoiceId}
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={9}
              rightColSpan={4}
              centerColSpan={1}
              leftColSpan={4}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{list.dispatch.deliveryPackId}</td>
                  <td>{list.dispatch.invoiceId}</td>
                  <td>{this.convertState(list.dispatch.lastState)}</td>
                  <td className="priceCell">{accounting.formatMoney(list.amount, '', ',')}</td>
                  <td>{list.account.name}</td>
                  <td>{list.account.bank}</td>
                  <td>{list.bankReference}</td>
                  <td>{list.paymentTime === null ? '-' : jMoment(list.paymentTime).format('jYYYY/jM/jD HH:mm')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارش پرداختی ها</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl=""
                  url={url}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_DETAIL + '/?export=true'}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>

                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="detailsInfoTable">
              <ul>
                <li>شناسه فاکتور : {invoiceId}</li>
                <li>نام رساننده : {name}</li>
              </ul>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>شناسه</td>
                    <td>شناسه فاکتور</td>
                    <td>حالت</td>
                    <td>مبلغ</td>
                    <td>نحوه پرداخت</td>
                    <td>اسم بانک</td>
                    <td>رفرنس بانک</td>
                    <td>زمان پرداخت</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.listPaid.map((list, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{list.dispatch.deliveryPackId}</td>
                      <td>{list.dispatch.invoiceId}</td>
                      <td>{this.convertState(list.dispatch.lastState)}</td>
                      <td className="priceCell">{accounting.formatMoney(list.amount, '', ',')}</td>
                      <td>{list.account.name}</td>
                      <td>{list.account.bank}</td>
                      <td>{list.bankReference}</td>

                      <td>{list.paymentTime === null ? '-' : jMoment(list.paymentTime).format('jYYYY/jM/jD HH:mm')}</td>

                      <td>
                        <button onClick={() => this.edit(index)}>
                          <img src={require('../../image/editDriver.svg')} alt={'edit'} />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.delete(index)}>
                          <img src={require('../../image/trash.svg')} alt={'trash'} />
                        </button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4}>مجموع</td>
                    <td className="priceCell">{accounting.formatMoney(this.state.aggregation.amount, '', ',')}</td>
                    <td colSpan={5} />
                  </tr>
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthProducts}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_DETAIL}
                  urlParams={urlParams}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
          <Loader show={this.state.loading} />
          <ModalHeader toggle={this.deleteCancel}>پرداخت</ModalHeader>
          <ModalBody>
            <p className="titleSm">از حذف پرداخت مطمئن هستید؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف پرداخت
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalEdit} toggle={this.editCancel} size="sm">
          <ModalHeader toggle={this.editCancel}>ویرایش</ModalHeader>
          <ModalBody>
            <Loader show={this.state.loading} />
            <form className="modalForm">
              <div className="formComponent">
                <label>
                  مقدار <span className="requireFiled">*</span>
                </label>
                <input type="text" defaultValue={amount} id="amount" className="form-control" />
              </div>
              <div className="formComponent">
                <label>
                  نوع پرداخت<span className="requireFiled">*</span>
                </label>
                <select id="typePaymentId" className="form-control" onChange={this.changeSelect.bind(this)}>
                  <option value="">-------</option>
                  {this.state.paymentList.map((pay, index) => (
                    <option
                      value={pay.id}
                      selected={pay.id === Number(accountId) ? true : false}
                      defaultValue={accountId}
                    >
                      {pay.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="formComponent">
                <label>رفرنس بانک </label>
                <input
                  type="text"
                  id="bankRefrence"
                  disabled={this.state.hasRef ? false : true}
                  onChange={this.changeRefrence}
                  value={this.state.bankReference}
                  className="form-control"
                />
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default detailsPaid
